export const CHAT_CONVERSATION_DELETED_EVENT =
  "fintheon:chat-conversation-deleted";

export function publishDeletedConversation(conversationId: string): void {
  window.dispatchEvent(
    new CustomEvent(CHAT_CONVERSATION_DELETED_EVENT, {
      detail: { conversationId },
    }),
  );
}

export function readDeletedConversationId(event: Event): string | null {
  const detail = (event as CustomEvent<{ conversationId?: unknown }>).detail;
  return typeof detail?.conversationId === "string"
    ? detail.conversationId
    : null;
}
